export const DisplayParams = {
  DEFAULT_PAGE_SIZE_DEFAULT: 50, // WARNING: shall be consistent with what is defined in backend-app/src/backend/routers/utils/const/display_params.py
} as const;
